import React, { useMemo } from 'react';
import { Row, Col, Space } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';
import LeagueSeasonSingleManage from './LeagueSeasonSingleManage';
import LeagueSeasonSingleShow from './LeagueSeasonSingleShow';
import WebLink from '../../../components/WebLink/WebLink';

const LeagueSeasonSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <WebLink
                path={`/leagues/season/${data.id}/${data.slug}`}
            />

            <Col
                className={'main'}
            >

                <Panel
                    heading={"League Season Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: "Title",
                                key: "title",
                                format: "link",
                            },
                            {
                                label: "Sport",
                                key: "sport",
                                format: "ModelLink"
                            }
                        ]}
                        columnB={[
                            {
                                label: "Status",
                                key: "status",
                                format: "titleCase"
                            },
                        ]}
                        columnC={[
                            {
                                label: "Host",
                                key: "host",
                                format: "modelLink"
                            },
                            {
                                label: "League",
                                key: "league",
                                format: "modelLink"
                            },
                        ]}
                    />

                </Panel>

                <Space />

                <LeagueSeasonSingleManage data={data} />

                {/* {data.sourceType === "spBasketball" &&
                    <>
                        <Space />

                        <LeagueSeasonData data={data} />
                    </>
                } */}

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

                <Space />

                <LeagueSeasonSingleShow data={data} />

            </Col>

        </Row>

    ), [data]);

}

export default LeagueSeasonSingleView;
